import { pipe, map } from "rxjs"
import { LeadRawValue } from "src/app/core/models/lead/lead-raw-value.model"
import { LeadRawValueDto } from "src/app/infrastructure/lobby-proxy/DTOs/lead-raw-value.dto"

export const mapLeadRawValueDtoToLeadRawValue = pipe(
    map((source: LeadRawValueDto) => leadRawValueDtoToLeadRawValue(source))
)

export function leadRawValueDtoToLeadRawValue(source: LeadRawValueDto): LeadRawValue {
    return {
        id: source.id,
        description: source.name,
        value: unescape(source.value),
        created: new Date(source.created),
        updated: new Date(source.updated)
    } as LeadRawValue
}

export function leadRawValuesToDtoChangesContainerRawValues(created: LeadRawValue[], changed: LeadRawValue[], removed: LeadRawValue[]) {
    return {
        creates: created.map(r => {
            return {
                name: r.description,
                value: String(r.value)
            }
        }),
        changes: changed.map(r => {
            return {
                id: r.id,
                name: r.description,
                value: String(r.value)
            }
        }),
        removes: removed.map(r => r.id)
    }
}